module.exports = __webpack_public_path__ + "img/logo13.48844e23.png";